import { render, staticRenderFns } from "./UpdateHolidayRule.vue?vue&type=template&id=332df785&scoped=true"
import script from "./UpdateHolidayRule.vue?vue&type=script&lang=js"
export * from "./UpdateHolidayRule.vue?vue&type=script&lang=js"
import style0 from "./UpdateHolidayRule.vue?vue&type=style&index=0&id=332df785&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332df785",
  null
  
)

export default component.exports